import * as React from 'react';
import { isPositiveNumeric } from 'app/infrastructure/data/number';
import styles from './period.scss';
import { SelectionTypeProps } from '../../types';
import { SelectItem } from 'app/area/reports/types';
import { mapToMenuItem, DropdownField } from 'app/area/reports/components/dropdown-field';
import { RadioSymbol } from 'ui';

import type { JSX } from "react";

type PeriodComponentProps = SelectionTypeProps

class PeriodComponent extends React.Component<PeriodComponentProps, {}> {
  private handleOnChange = () => {
    this.props.onChange({
      ...this.props.selectionField.value,
      type: this.props.selectionItem.type,
      period: this.props.selectionItem.periods[0]
    });
  };

  private onSelectPeriod = (selectedoption: SelectItem) => {
    this.props.onChange({
      ...this.props.selectionField.value,
      rollingAverage: !!selectedoption.allowRollingAverage && !!this.props.selectionField.value
        ? this.props.selectionField.value.rollingAverage : undefined,
      period: selectedoption
    });
  };

  private handleChangeRollingAverage = (e: React.SyntheticEvent<HTMLInputElement>) => {
    const { value } = e.currentTarget;
    const { selectionField } = this.props;
    let nextValue = selectionField.value.rollingAverage;

    if (isPositiveNumeric(value)) {
      nextValue = parseInt(value, 10);
    } else if (typeof value === 'string' && value.trim() === '') {
      nextValue = undefined;
    }
    this.props.onChange({
      ...selectionField.value,
      rollingAverage: nextValue
    });
  };

  private renderRollingAverage = () => {
    const {
      selectionField: { value, field },
      selectionItem: { periods },
      translation
    } = this.props;

    const selectedOption = !!value.period ? periods.find(p => p.value === value.period.value) : undefined;
    const stringValue = !!value.rollingAverage ? value.rollingAverage : '';
    const textInputId = `text-input-${field.description.replace(/\s+/g, '')}-${field.value}`;
    const inputDescription = `text-description-${field.description.replace(/\s+/g, '')}-${field.value}`;

    return (
      <div className={styles.rollingAverage}>
        <label htmlFor={textInputId} className="control-label">
          {translation.group_by_rolling_average}
        </label>
        <div className={styles.inputRow}>
          <div>
            <input
              id={textInputId}
              className="form-control"
              type="text"
              onChange={this.handleChangeRollingAverage}
              value={stringValue}
              aria-describedby={inputDescription}
            />
          </div>
          <label className="control-label" id={inputDescription}>
            {selectedOption ? selectedOption.rollingAverageDescription : ''}
          </label>
        </div>
      </div>
    );
  };

  public render(): JSX.Element {
    const {
      selectionField: {
        value
      },
      selectionItem,
      checked,
      isFirstSelection
    } = this.props;
    const option = selectionItem.periods.find(i => value.period && i.value === value.period.value);
    const selectedPeriodOption = option && mapToMenuItem(option);
    const periodOptions = selectionItem.periods.map(l => mapToMenuItem(l, () => this.onSelectPeriod(l)));
    const valid = isFirstSelection && !!option && option.allowRollingAverage ? true : false;

    const uniqueId = `period-${this.props.selectionField?.selectionNo}`;
    const hasMoreFields = checked || valid;
    return (<>
      <input
        type="radio"
        className="form-check-input visuallyhidden"
        id={uniqueId}
        value={value.type}
        checked={checked}
        onChange={this.handleOnChange}
      />
      <label htmlFor={uniqueId} className="form-check-label">
        <RadioSymbol />
        {selectionItem.label}
      </label>
      {hasMoreFields && <div className="input-wrapper">
        {checked && <DropdownField
          selectedItem={selectedPeriodOption}
          options={periodOptions}
        />}
        {valid && this.renderRollingAverage()}
      </div>}
    </>);
  }
}

export const Period = PeriodComponent;
